import {
  MT5_DEPOSIT_WIDTHDRAW,
  MT5_DEPOSIT_WIDTHDRAW_SUCCESS,
  MT5_DEPOSIT_WIDTHDRAW_FAILURE,
} from "../actionTypes";

export const mt5DepositWidthDraw = (payload) => ({
  type: MT5_DEPOSIT_WIDTHDRAW,
  payload,
});

export const mt5DepositWidthDrawSuccess = (payload) => ({
  type: MT5_DEPOSIT_WIDTHDRAW_SUCCESS,
  payload,
});

export const mt5DepositWidthDrawFailure = () => ({
  type: MT5_DEPOSIT_WIDTHDRAW_FAILURE,
});
